import * as React from "react";
import Box from "@mui/material/Box";
import CssBaseline from "@mui/material/CssBaseline";
import AppTopBar from "../layout/subcomponents/header";
import BottomBar from "../layout/subcomponents/footer";
import SideMenu from "../layout/subcomponents/sideMenu";
import { LayoutProvider } from "../../middlewares/LayoutContext";

function Layout() {
  return (
    <LayoutProvider>
      <Box sx={{ display: "flex" }}>
        <CssBaseline />
        <AppTopBar />
        <SideMenu />
        <BottomBar />
      </Box>
    </LayoutProvider>
  );
}

export default Layout;
